'use client';

import * as React from 'react';

import { Plate, usePlateEditor } from 'platejs/react';

import { EditorKit } from '@/components/editor/editor-kit';
import { SettingsDialog } from '@/components/editor/settings-dialog';
import { Editor, EditorContainer } from '@/components/ui/editor';
import { countWords } from '@/lib/plate-html';

/**
 * Distraction-free article editor used by ArticleDetailPage.
 *
 * `initialValue` is only used at mount time — to reload content, remount with a
 * new React `key` (the page bumps its own editorKey on refresh/apply-rewrite).
 */
export default function PlateArticleEditor({
  initialValue,
  onWordCount,
  onEditorReady,
  className,
}) {
  const editor = usePlateEditor({
    plugins: EditorKit,
    value: initialValue,
  });

  React.useEffect(() => {
    onEditorReady?.(editor);
  }, [editor, onEditorReady]);

  return (
    <Plate
      editor={editor}
      onChange={({ value }) => onWordCount?.(countWords(value))}
    >
      <EditorContainer className={className}>
        <Editor variant="demo" />
      </EditorContainer>
      <SettingsDialog />
    </Plate>
  );
}
